import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const counterpartyFundTypeEnum = createEnum({
    LEND: ['lend', '出借（我们借款给别人）', 'blue'],
    BORROW: ['borrow', '借款（别人借款给我们）', 'purple'],
});
export const COUNTERPARTY_FUND_TYPES = enumValues(counterpartyFundTypeEnum);
export const COUNTERPARTY_FUND_TYPE_LABEL_MAP = enumLabelMap(counterpartyFundTypeEnum);
export const counterpartyFundDirectionStatusEnum = createEnum({
    NOT_STARTED: ['not_started', '未开始', 'default'],
    DRAFT: ['draft', '草稿', 'default'],
    REVIEWING: ['reviewing', '审批中', 'processing'],
    REVIEW_REJECTED: ['review_rejected', '审批拒绝', 'red'],
    PENDING: ['pending', '待处理', 'orange'],
    PARTIAL: ['partial', '部分处理', 'blue'],
    COMPLETED: ['completed', '全部完成', 'cyan'],
    REJECTED: ['rejected', '处理拒绝', 'red'],
});
export const COUNTERPARTY_FUND_DIRECTION_STATUSES = enumValues(counterpartyFundDirectionStatusEnum);
export const COUNTERPARTY_FUND_DIRECTION_STATUS_LABEL_MAP = enumLabelMap(counterpartyFundDirectionStatusEnum);
export const counterpartyFundOperationTypeEnum = createEnum({
    LEND_PAYMENT: ['lend_payment', '出借付款', 'blue'],
    LEND_REPAYMENT_RECEIPT: ['lend_repayment_receipt', '还款入账', 'green'],
    BORROW_RECEIPT: ['borrow_receipt', '借款入账', 'green'],
    BORROW_REPAYMENT: ['borrow_repayment', '借款还款', 'blue'],
});
export const COUNTERPARTY_FUND_OPERATION_TYPES = enumValues(counterpartyFundOperationTypeEnum);
export const COUNTERPARTY_FUND_OPERATION_TYPE_LABEL_MAP = enumLabelMap(counterpartyFundOperationTypeEnum);
export const counterpartyFundOperationStatusEnum = createEnum({
    REVIEWING: ['reviewing', '审批中', 'processing'],
    SETTLING: ['settling', '处理中', 'orange'],
    PARTIALLY_SETTLED: ['partially_settled', '部分完成', 'blue'],
    COMPLETED: ['completed', '全部完成', 'cyan'],
    REJECTED: ['rejected', '已拒绝', 'red'],
});
export const COUNTERPARTY_FUND_OPERATION_STATUSES = enumValues(counterpartyFundOperationStatusEnum);
export const COUNTERPARTY_FUND_OPERATION_STATUS_LABEL_MAP = enumLabelMap(counterpartyFundOperationStatusEnum);
export const counterpartyFundActionEnum = createEnum({
    DRAFT: ['draft', '保存草稿', 'default'],
    SUBMIT: ['submit', '提交', 'blue'],
});
export const COUNTERPARTY_FUND_ACTIONS = enumValues(counterpartyFundActionEnum);
export const COUNTERPARTY_FUND_ACTION_LABEL_MAP = enumLabelMap(counterpartyFundActionEnum);
//# sourceMappingURL=counterparty-fund.js.map